/**
 * API Configuration for SuperAdmin Frontend
 */

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1'

export const API_CONFIG = {
  baseURL: API_BASE_URL,
  endpoints: {
    auth: {
      login: '/auth/login',
      logout: '/auth/logout',
      refresh: '/auth/refresh',
      me: '/auth/me',
    },
    superadmin: {
      users: '/superadmin/users',
      events: '/superadmin/events',
      stats: '/superadmin/stats',
    },
  },
}

